<template>
    <b-container class="pb-5 mb-5 flex-1">
        <b-row class="mt-5 mb-5">
            <b-col>
                <h2>Conferences</h2>
            </b-col>
        </b-row>

        <b-card class="conference mb-3" v-for="conf in conferences">
            <b-row>
                <b-col cols="7">
                    <h6>{{conf.title}} <b-badge variant="light" class="ml-3"><i class="fas fa-tag mr-2"></i>{{conf.code}}</b-badge></h6>
                    <div>{{conf.start_at | moment('dddd, MMMM Do, YYYY')}} - {{conf.end_at | moment('dddd MMMM Do, YYYY')}}</div>
                    <div>{{conf.registrations.length - conf.pending}} Registrations - {{conf.revenue | currency}} <span class="text-muted" v-if="conf.pending > 0">({{conf.pending}} for {{conf.pendingRevenue | currency}} pending)</span></div>
                </b-col>
                <b-col class="text-right">
                    <b-button variant="success" class="mr-2" :to="{name: 'admin-conf', params: {confId: conf.id}}"><i class="fas fa-search mr-2"></i> Details</b-button>
                </b-col>
            </b-row>
        </b-card>

    </b-container>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "org-dashboard",
        data() {
            return {
                conferences: [],
                activateCode: null,
                processing: false
            }
        },
        methods: {
            ...mapActions(['getConferencesByOrgId']),
        },
        mounted: function () {
            this.getConferencesByOrgId(this.$route.params.id).then(results => {
                this.conferences = results;
            });
        }
    }
</script>


<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';
</style>
